import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useI18n } from '../providers/I18nProvider';
export const T = ({ values, ...props }) => {
    const intl = useI18n();
    return (_jsx(_Fragment, { children: intl.$t({
            ...props,
        }, values) }, void 0));
};
//# sourceMappingURL=T.js.map